/**
 * File: image-carousel.js
 *
 * Import and initialize functions for the Search button
 */

export default {
	init() {
		this.render();
	},
	render() {
		const searchBtn = document.querySelector(".search_submit");
		const searchCloseBtn = document.querySelector(".search_close");
		const searchWrapper = document.querySelector(".search_wrap");
		const searchInput = searchWrapper.querySelector(".search_field");
		const searchForm = searchWrapper.querySelector(".search_form");

		const toggleAria = () => {
			const isSearchOpened = searchWrapper.classList.contains("search_opened");
			if (isSearchOpened) {
				searchInput.setAttribute("type", "text");
			} else {
				searchInput.setAttribute("type", "hidden");
			}
		};

    /* a11y */
		searchForm.removeAttribute("role");
		searchCloseBtn.setAttribute("aria-label", "close button");

    /* Click events */
		searchBtn.addEventListener("click", toggleAria);
		searchCloseBtn.addEventListener("click", toggleAria);

    const hideSearchModal = () => {
      searchInput.setAttribute("type", "hidden");
      searchWrapper.classList.remove('search_opened');
    }

    /* Keydown events */
    searchCloseBtn.addEventListener("keydown", e => {
      if (e.keyCode === 13) {
        hideSearchModal();
			}
    })
		searchWrapper.addEventListener("keydown", e => {
			if (e.key === "Escape" || e.key == "Esc") {
				hideSearchModal();
			}
		});
	},
};
